module.exports = ".input-group-sm {\n  border: 1px solid lightgray;\n  border-radius: 3px;\n  margin: auto;\n  max-width: 125px; }\n\n.input-group-addon {\n  color: black;\n  width: auto;\n  background-color: lightgray;\n  border-color: lightgray; }\n\n.input-group-addon:hover {\n  background-color: #46b8da;\n  border-color: #46b8da;\n  color: white; }\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0; }\n\ninput {\n  text-align: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/paginator/paginator.component.scss
// module id = 1161
// module chunks = 1